import React from 'react';
import { FooterProps, Icon } from '@sato/components';

import {
  ConditionDependencies,
  filterConditionalEntries,
} from '@/contentful/components';

import { Link } from '@components/common/Link';
import { isInternalPath } from '@utils/link.utils';

import {
  IListedLink,
  IOmaSatoFooter,
  ParsedEntry,
} from '../../contentful/types';

const formatLink = (linkEntry: ParsedEntry<IListedLink>) => ({
  to: linkEntry.url ?? '#',
  children: linkEntry.title,
  icon:
    linkEntry.icon?.icon ??
    (!isInternalPath(linkEntry.url) ? 'externalLink' : undefined),
});

type ParseFooterDataProps = Omit<
  ParsedEntry<IOmaSatoFooter>,
  'linkGroups' | 'iconLinks' | 'socialMediaLinks'
> &
  Pick<
    FooterProps<typeof Link> & { variant: 'omaSATO' },
    'linkGroups' | 'iconLinks' | 'socialMediaLinks'
  >;

/** Parses footer data from Contentful into Footer component props */
export const parseFooterData = (
  data: ParsedEntry<IOmaSatoFooter>,
  conditionDeps: ConditionDependencies
): ParseFooterDataProps => ({
  ...data,
  linkGroups: data.linkLists.map(({ title, links }) => ({
    title: title ?? '?',
    links: filterConditionalEntries(links, { deps: conditionDeps }).map(
      formatLink
    ),
  })),
  iconLinks: data.iconLinks.map((link) => {
    const { icon, to } = formatLink(link);

    return {
      to,
      icon,
    };
  }),
  socialMediaLinks: data.socialMediaLinks.map((link) => {
    const { icon, to, children } = formatLink(link);

    return {
      to,
      children: icon ? <Icon icon={icon} size="sm" /> : children,
    };
  }),
});
